import styled, { css } from 'styled-components';
import { FilterRadioButtonInterface } from './interface';

export const SecondaryButton = styled.button<FilterRadioButtonInterface>`
      color: ${({ theme, selected }) => (selected ? theme.colors.lighterBackground : theme.colors.primary.main)};
      background: ${({ theme, selected }) => (selected ? theme.colors.primary.main : theme.colors.background)};
      text-decoration: none;
      font-weight: bold;
      border: 2px solid ${({ theme }) => theme.colors.primary.main};
      padding: 4px 8px;
      border-radius: 16px;
      transition: all 0.2s ease-in;
      font-size: 14px;
      height: 36px;
      margin: 1px;
      display: ${({ invisible }) => invisible && 'none'}!important;

      @media(max-width: 500px) {
        font-size: 12px;
        height: 40px;
        padding: 2px 8px;

        ${({ sameWidth }) => sameWidth && css`
          min-width: 200px;
        `};
        /* min-width: 200px; */
      }

      & + & {
        margin-left: 8px;
      }
      @media(max-width: 500px){
        & + & {
          margin-left: 0px;
        }
      }

      &:hover {
        background: ${({ theme, selected }) => (!selected && theme.colors.primary.main)};
        color: ${({ theme }) => (theme.colors.lighterBackground)};
      }
`;
